<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb2"></question-title>
      <div
        class="field mt1 has-text-left"
        v-for="field in question.fields"
        :key="field.id"
      >
        <label class="checkbox">
          <i
            :class="[
              'pt1',
              { 'icon icon-check-square-o': isChecked(field.choice) },
              { 'icon icon-square-o': !isChecked(field.choice) }
            ]"
          ></i>
          <input type="checkbox" v-model="choice" :value="field.choice" />
          {{ field.choice }}
        </label>
      </div>

      <next-button :id="question.id" :choice="choice"></next-button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { camelize } from "humps";
import baseQuestion from "./baseQuestion";

export default {
  name: "checkbox",

  mixins: [baseQuestion],

  watch: {
    choice(_newVal, _oldVal) {
      this.recordAnswer();
    }
  },

  computed: {
    fieldName() {
      return camelize(this.question.title);
    }
  },
  methods: {
    isChecked(field) {
      return _.isArray(this.choice) && this.choice.indexOf(field) > -1;
    },

    recordAnswer() {
      if (
        (this.question.required && this.choice.length > 0) ||
        !this.question.required
      ) {
        this.$store.dispatch("interview/setNext", true);
      } else {
        this.$store.dispatch("interview/setNext", false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
input[type="checkbox"] {
  display: none;
}
</style>
